const SuccessModal = ({ setOpen, message = "Processing successful.", }) => {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-[350px] p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-xl font-semibold text-green-600">Success!!!</h2>
        <p className="mt-2 text-gray-600">
          {message}
        </p>

        <button
          className="mt-5 bg-blue-600 text-white px-6 py-2 rounded"
          onClick={() => setOpen(false)}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
